<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" lazy-validation>
            <v-card-title>Créer verset groupe avec sous-thème </v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="6" md="3" xs="12">
                  <v-select v-model="surat" :return-object="true" clearable label="Surat" :items="suratArray"
                    item-text="frenchName" outlined @change="getListversetBySouratId"></v-select>
                </v-col>
                <v-col v-if="surat">
                  <v-autocomplete :return-object="true" clearable v-model="selectedVerset" :items="listVersetBySurate"
                    item-text="french_text" label="Début du groupe verset" variant="outlined"
                    @change="updateFinDuGroupeVerset"></v-autocomplete>
                </v-col>
                <v-col v-if="surat">
                  <v-autocomplete :return-object="true" clearable v-model="selectedFinVerset" :items="filteredFinVerset"
                    item-text="french_text" label="Fin du groupe verset" variant="outlined"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6" xs="12">
                  <v-select v-model="theme" clearable label="Theme" :items="themeArray" item-text="title"
                    item-value="id" outlined @change="getListProphete(theme)"></v-select>
                </v-col>

                <v-col v-if="theme || selectedVerset">
                  <v-select v-model="Soustheme" clearable label="Sous Theme" :items="filteredProphets" item-text="name"
                    item-value="id" outlined></v-select>
                </v-col>

                <!--<v-col v-if="surat">
                  <v-range-slider
                    v-model="range"
                    :max="surat === null ? 1 : surat.versetNumber"
                    :min="min"
                    hide-details
                    class="align-center"
                  >
                    <template v-slot:prepend>
                      <v-text-field
                        :value="range[0]"
                        class="mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px"
                        @change="$set(range, 0, $event)"
                      ></v-text-field>
                    </template>
<template v-slot:append>
                      <v-text-field
                        :value="range[1]"
                        class="mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px"
                        @change="$set(range, 1, $event)"
                      ></v-text-field>
                    </template>
</v-range-slider>
</v-col> -->
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn class="ml-6 mt-4" color="error" @click="ClearVersetHasGroupe()">
                      Clear
                    </v-btn>
                    <v-btn class="ml-6 mt-4" color="info" @click="ConfirmeVersetHasGroupe()"
                      :disabled="Soustheme === null || selectedVerset === null" :loading="isLoadingAdd">
                      Enregistrer
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-card-title>List verset groupe sous-thème </v-card-title>
          <v-card-text class="mt-4">
            <v-row>
              <!-- <v-col cols="12" sm="12" md="12" xs="12">
                <v-select
                  v-model="suratList"
                  :return-object="true"
                  clearable
                  label="Surat"
                  :items="suratArray"
                  item-text="frenchName"
                  outlined
                  @change="getGroupeversetBySouratId"
                ></v-select>
              </v-col> -->
              <v-col cols="6" sm="6" md="6" xs="12">
                <v-select v-model="themeSelected" clearable label="Theme" :items="themeArray" item-text="title"
                  item-value="id" outlined @change="getSousThemeList(themeSelected)"></v-select>
              </v-col>

              <v-col v-if="themeSelected">
                <v-select v-model="Soustheme" clearable label="Sous Theme" :items="filteredSoustheme" item-text="name"
                  item-value="id" outlined @change="getListVersetByThemeAndSousTheme"></v-select>
              </v-col>

              <v-col cols="12" sm="12" md="12" xs="12">
                <v-data-table :loading="isLoadingTables" :headers="headerss" :items="groupedVersets" class="elevation-1"
                  loading-text="Loading..." item-key="id" hide-default-footer>
                  <template v-slot:body="{ items }">
                    <tbody>
                      <template v-for="group in items">
                        <template v-for="(verset, i) in group.versets">
                          <tr :key="verset.versetId">
                            <!-- Utilisation de rowspan pour afficher le versetGroup sur plusieurs lignes -->
                            <td v-if="i === 0" :rowspan="group.versets.length" class="text-bold">
                              {{ group.versetGroup }}
                            </td>
                            <td>{{ verset.verset_number }}</td>
                            <td>{{ verset.verset_arabic }}</td>
                            <td>{{ verset.verset_french }}</td>
                            <td>{{ verset.verset_english }}</td>
                            <td v-if="i === 0" :rowspan="group.versets.length">
                              <v-btn icon @click="EditAction(group)">
                                <v-icon>{{ icons.mdiPencil }}</v-icon>
                              </v-btn>
                            </td>
                            <td v-if="i === 0" :rowspan="group.versets.length">
                              <v-btn icon @click="suppressionAction(verset)">
                                <v-icon> {{ icons.mdiDeleteOutline }}</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </template>
                      </template>
                    </tbody>
                  </template>
                </v-data-table>
                <div class="d-flex flex-row-reverse">
                  <v-btn class="ml-6 mt-4" color="info" @click="getNextPage" :disabled="!nextPage">
                    suivant
                  </v-btn>
                  <v-btn class="ml-6 mt-4" color="info" @click="getPreviousPage" :disabled="!previousPage">
                    precedant
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogAlerteAddGroupe" persistent max-width="600">
        <v-card>
          <v-card-title style="text-align: center" class="justify-center mb-2">
            Groupement existait déjà ou veset dans un autre groupe.
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="info darken-1 " text @click="Clear()"> OK </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="alerteExist" persistent max-width="600">
        <v-card>
          <v-alert v-if="alerteExist" type="error">
            Groupement existait déjà ou veset dans un autre groupe.
          </v-alert>
          <v-card-title style="text-align: center" class="justify-center mb-2">
            Etes vous sur de vouloir ajouter le groupe verset ?
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="cancelleCallback">
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="AddGroupeVerset()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteGroupe" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer le Groupe ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="dialogDeleteGroupe = false">
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="deleteGroupe()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogEditGroupe" persistent max-width="800">
        <v-card>
          <v-alert v-if="alerteExistEdit" type="error">
            Groupement existait déjà ou veset dans un autre groupe.
          </v-alert>
          <v-card-text class="mt-4">
            <v-row>
              <v-col cols="12" sm="12" md="12" xs="12">
                <v-autocomplete :return-object="true" clearable v-model="selectedVersetToEdit"
                  :items="listVersetBySurateToEdit" item-text="french_text" label="Début du groupe verset"
                  variant="outlined" @change="updateFinDuGroupeVersetToEdit"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" xs="12">
                <v-autocomplete :return-object="true" clearable v-model="selectedFinVersetToEdit"
                  :items="filteredFinVersetToEdit" item-text="french_text" label="fin du groupe verset"
                  variant="outlined"></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="CancelEditGroupe()">
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="ConfirmeEditGroupe()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--
    <v-row justify="center">
      <v-dialog v-model="dialogAddGroupe" max-width="600">
        <v-card>
          <v-card-title style="text-align: center;" class="justify-center mb-2">
            Cree un Groupe verst
          </v-card-title>
          <v-card-title>
            Sélectionner le début et la fin du verset Groupe
          </v-card-title>
          <v-col v-if="surat" style="padding: 25px;">
            <v-range-slider
              v-model="range"
              :max="surat === null ? 1 : surat.versetNumber"
              :min="min"
              hide-details
              class="align-center"
            >
              <template v-slot:prepend>
                <v-text-field
                  :value="range[0]"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  type="number"
                  style="width: 60px"
                  @change="$set(range, 0, $event)"
                ></v-text-field>
              </template>
              <template v-slot:append>
                <v-text-field
                  :value="range[1]"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  type="number"
                  style="width: 60px"
                  @change="$set(range, 1, $event)"
                ></v-text-field>
              </template>
            </v-range-slider>
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogAddGroupe = false"
            >
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="AddGroupeVerset()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row> -->
    <!--dialogSelectGroupe-->
    <!-- <v-row justify="center">
      <v-dialog v-model="dialogSelectGroupe" max-width="600">
        <v-card>
          <v-card-title style="text-align: center;" class="justify-center mb-2">
            Sélectionner un Groupe Verset
          </v-card-title>
          <v-col cols="12" sm="12" md="12">
            <v-radio-group
              v-model="selectedGroupeValue"
              label="Select group Verset"
            >
              <v-radio
                v-for="item in radioOptions"
                :key="item.versetGroupId || index"
                :label="generateLabel(item)"
                :value="item.versetGroupId"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-card-title style="text-align: center;" class="justify-center mb-2">
            <v-btn color="info" @click="CreatNewGrouope()">
              Cree un Groupe verst</v-btn
            >
          </v-card-title>

          <v-col cols="12" sm="12" md="12"> </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogSelectGroupe = false"
            >
              Annuler
            </v-btn>

            <v-btn
              :disabled="selectedGroupeValue === null"
              color="info darken-1 "
              text
              @click="SelectGroupeVerset()"
            >
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>-->
  </section>
</template>
<script>
import { component as VueCodeHighlight } from "vue-code-highlight";
import {
  mdiPlus,
  mdiDeleteOutline,
  mdiPencil,
  mdiDatabasePlusOutline,
} from "@mdi/js";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import axios from "axios";
import Constant from "@/utils/constants";
import {
  getAllSurat,
  getAllVersetBySurate,
  getAllTheme,
  getAllProphete,
} from "@/views/qorani/services/services";
export default {
  components: { VueEditor, VueCodeHighlight },
  data() {
    return {
      currentPage: 1,
      isLoadingAdd: false,
      dialogAlerteAddGroupe: false,
      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil,
        mdiDatabasePlusOutline,
      },
      headerss: [
        { text: "Verset Groupe", align: "start", value: "versetGroup" },
        { text: "Numéro de verset", align: "start", value: "verset_number" },
        { text: "Verset Arabe", value: "verset_arabic" },
        { text: "Verset Français", value: "verset_french" },
        { text: "Verset Anglais", value: "verset_english" },
        { text: "Modifier", value: "modifier", sortable: false },
        { text: "Supprimer", value: "Supprimer", sortable: false },
      ],
      suratId: null,
      isLoadingTables: false,
      suratList: null,
      radioOptions: [],
      selectedGroupeValue: null,

      nextPage: true,
      previousPage: false,

      listVersetBySurate: [],
      suratArray: [],
      surat: null,
      min: 1,
      max: 800,
      range: [0, 1],
      versetGroupeArray: [],
      selectedVerset: null,
      selectedFinVerset: null,
      filteredFinVerset: [],
      themeArray: [],
      theme: null,
      Soustheme: null,
      SousthemeSelected: null,
      themeSelected: null,
      PropheteArray: [],
      filteredProphets: [],
      filteredSoustheme: [],
      dialogAddGroupe: false,
      dialogSelectGroupe: false,
      versetGroup: {
        suratId: "",
        verset_start: "",
        verset_end: "",
      },
      PropheteToVerset: {
        versetId: "",
        propheteId: "",

        versetGroupId: "",
      },
      alerteExist: false,
      listVersetByThemeAndSousTheme: [],
      dialogDeleteGroupe: false,
      idGroupeSupprimmer: null,
      dialogEditGroupe: false,
      idGroupeEdit: null,
      listVersetBySurateToEdit: [],
      selectedVersetToEdit: null,
      selectedFinVersetToEdit: null,
      filteredFinVersetToEdit: [],
      alerteExistEdit: false,
    };
  },
  computed: {
    groupedVersets() {
      const groups = {};
      this.listVersetByThemeAndSousTheme.forEach((item) => {
        if (!groups[item.versetGroup]) {
          groups[item.versetGroup] = {
            versetGroup: item.versetGroup,
            versets: [],
            suratId: item.suratId,
          };
        }
        groups[item.versetGroup].versets.push(item);
      });
      return Object.values(groups);
    },
  },
  methods: {
    Clear() {
      this.dialogAlerteAddGroupe = false;
      this.dialogEditGroupe = false;
      this.dialogAddGroupe = false;
    },
    ClearVersetHasGroupe() {
      this.theme = null;
      this.Soustheme = null;
      this.surat = null;
      this.selectedVerset = null;
      this.selectedFinVerset = null;
      this.filteredFinVerset = [];
      this.filteredProphets = [];
    },
    async ConfirmeEditGroupe() {
      try {
        const versetGroupeEdit = {};
        versetGroupeEdit.sousThemeId = this.Soustheme;
        versetGroupeEdit.versetGroupStart =
          this.selectedVersetToEdit.verse_number;
        versetGroupeEdit.versetGroupEnd =
          this.selectedFinVersetToEdit.verse_number;

        const response = await fetch(
          Constant.QORANI + `verset/editPropheteToVerset/${this.suratId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(versetGroupeEdit),
          }
        );
        console.log(versetGroupeEdit);
        console.log(this.suratId);

        // Check if the response status is ok
        if (response.ok) {
          const jsonResponse = await response.json();

          console.log("API Response:", jsonResponse.success);
          if (jsonResponse.success) {
            console.log("API Response:", jsonResponse);
            window.location.reload();
          } else {
            console.log("API Response:", jsonResponse);

            this.dialogAlerteAddGroupe = true;
          }
        } else {
          console.error("Request failed with status:", response.status);
        }
      } catch (error) {
        console.error("Error during API call:", error);
      }
    },
    CancelEditGroupe() {
      this.idGroupeEdit = null;
      this.dialogEditGroupe = false;
      this.selectedFinVersetToEdit = null;
      this.selectedVersetToEdit = null;
      this.alerteExistEdit = false;
    },
    updateFinDuGroupeVersetToEdit() {
      if (this.selectedVersetToEdit) {
        const selectedVerseNumber = this.selectedVersetToEdit.verse_number;
        this.selectedFinVersetToEdit = null;
        this.filteredFinVersetToEdit = this.listVersetBySurateToEdit.filter(
          (verse) => verse.verse_number >= selectedVerseNumber
        );
      }
    },
    async EditAction(item) {
      this.listVersetBySurateToEdit = await getAllVersetBySurate(item.suratId);
      this.suratId = item.suratId;
      this.idGroupeEdit = item;
      this.dialogEditGroupe = true;
    },
    suppressionAction(item) {
      this.idGroupeSupprimmer = item;
      this.deleteGroupe();
    },
    async deleteGroupe() {
      const id = this.idGroupeSupprimmer.versetGroupId;
      const response = await fetch(
        Constant.QORANI + `verset/deletePropheteFromVersetId/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      try {
        this.dialogDeleteGroupe = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la suppression du juz, veuillez réessayez plus tard, Merci."
        );
        this.dialogDeleteGroupe = false;
      }
    },
    async getListVersetByThemeAndSousTheme() {
      this.isLoadingTables = true;
      const pageToFetch = this.currentPage - 1; // ajuster pour 0-indexed pagination
      try {
        const response = await axios.get(
          `${Constant.QORANI}verset/Prophete/${this.Soustheme}/Theme/${this.themeSelected}/Page/${pageToFetch}/`
        );
        const listLength = response.data.length;
        this.listVersetByThemeAndSousTheme = response.data;

        if (this.currentPage == 1) {
          this.previousPage = false
        }

        if (listLength === 100) {
          this.nextPage = true
          this.previousPage = true
        }
        else {
          this.nextPage = false
        }
      } catch (error) {
        console.error("An error occurred:", error);
      }
      this.isLoadingTables = false;
    },
    // Fonction pour aller à la page suivante
    async getNextPage() {
      this.currentPage += 1;
      await this.getListVersetByThemeAndSousTheme(this.currentPage);
    },

    // Fonction pour aller à la page précédente
    async getPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        await this.getListVersetByThemeAndSousTheme(this.currentPage);
      }
    },

    async getGroupeversetBySouratId() {
      this.isLoadingTables = true;
      try {
        const response = await axios.get(
          `${Constant.QORANI}versetGroup/getallBySuratId/${this.suratList.suratId}`
        );
        this.listVersetByThemeAndSousTheme = response.data;
      } catch (error) {
        console.error("An error occurred:", error);
        throw error;
      }
      this.isLoadingTables = false;
    },
    cancelleCallback() {
      this.dialogAddGroupe = false;
      this.alerteExist = false;
    },
    ConfirmeVersetHasGroupe() {
      this.dialogAddGroupe = true;
      this.AddGroupeVerset();
    },

    updateFinDuGroupeVerset() {
      if (this.selectedVerset) {
        const selectedVerseNumber = this.selectedVerset.verse_number;
        this.selectedFinVerset = null;
        this.filteredFinVerset = this.listVersetBySurate.filter(
          (verse) => verse.verse_number >= selectedVerseNumber
        );
      }
    },
    CreatNewGrouope() {
      this.dialogSelectGroupe = false;
      this.dialogAddGroupe = true;
    },
    generateLabel(item) {
      return `Depuis le Verst ${item.verset_start} à Verst ${item.verset_end}`;
    },
    async AddGroupeVerset() {
      this.isLoadingAdd = true;
      try {
        const versetGroupe = {};
        versetGroupe.suratId = this.surat.suratId;
        versetGroupe.sousThemeId = this.Soustheme;
        versetGroupe.versetGroupStart = this.selectedVerset.verse_number;
        versetGroupe.versetGroupEnd = this.selectedFinVerset.verse_number;

        const response = await fetch(
          Constant.QORANI + "verset/addPropheteToVerset",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(versetGroupe),
          }
        );

        // Check if the response status is ok
        if (response.ok) {
          const jsonResponse = await response.json();

          console.log("API Response:", jsonResponse.success);
          if (jsonResponse.success) {
            console.log("API Response:", jsonResponse.success);
            window.location.reload();
          } else {
            this.dialogAlerteAddGroupe = true;
          }
        } else {
          console.error("Request failed with status:", response.status);
        }
      } catch (error) {
        console.error("Error during API call:", error);
      }
      finally {
        this.isLoadingAdd = false;
      }
    },

    async isVersetHasGroupe() {
      try {
        const response = await fetch(
          Constant.QORANI +
          `versetGroup/isVersetHasGroupe/${this.selectedVerset.versetId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();

        if (data.length > 0) {
          const uniqueSet = new Set(data.map((item) => item.versetGroupId));
          const uniqueData = Array.from(uniqueSet).map((versetGroupId) => {
            return data.find((item) => item.versetGroupId === versetGroupId);
          });

          this.dialogSelectGroupe = true;
          this.radioOptions = uniqueData;
        } else {
          this.dialogAddGroupe = true;
        }
      } catch (error) {
        console.error("Error:", error);
        // Handle the error as needed, e.g., show a message to the user.
      }
    },
    async getListversetBySouratId() {
      this.selectedFinVerset = null;
      this.filteredFinVerset = [];
      this.listVersetBySurate = await getAllVersetBySurate(this.surat.suratId);
    },
    async getListProphete(theme) {
      if (theme === null) {
        this.filteredProphets = [];
        return;
      }
      this.filteredProphets = this.PropheteArray.filter((prophet) =>
        prophet.listThemeId.includes(theme)
      );
    },
    async getSousThemeList(themeId) {
      if (themeId === null) {
        this.filteredSoustheme = [];
        return;
      }
      this.filteredSoustheme = this.PropheteArray.filter((prophet) =>
        prophet.listThemeId.includes(themeId)
      );
    },

    async SelectGroupeVerset() {
      if (this.theme) {
        this.selectedVerset.themeId = this.theme;

        try {
          const responseUPDATE = await fetch(
            Constant.QORANI + "verset/edit/" + this.selectedVerset.versetId,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(this.selectedVerset),
            }
          );

          if (!responseUPDATE.ok) {
            throw new Error("Error updating the verse.");
          }

          // Add PropheteToVerset
          this.PropheteToVerset.versetGroupId = this.selectedGroupeValue;
          this.PropheteToVerset.versetId = this.selectedVerset.versetId;
          this.PropheteToVerset.propheteId = this.Soustheme;

          try {
            const response2 = await fetch(
              Constant.QORANI + "verset/addPropheteToVerset",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(this.PropheteToVerset),
              }
            );

            if (!response2.ok) {
              throw new Error("Error adding PropheteToVerset.");
            }
            if (response2.ok) {
              window.location.reload();
            }
          } catch (error) {
            alert(
              "Une erreur est survenue lors de l'ajout du verset, veuillez réessayer plus tard. Merci."
            );
          }
        } catch (error) {
          alert(
            "Une erreur est survenue lors de l'ajout de la surat, veuillez réessayez plus tard, Merci."
          );
        }
      } else {
        // Add PropheteToVerset
        this.PropheteToVerset.versetGroupId = this.selectedGroupeValue;
        this.PropheteToVerset.versetId = this.selectedVerset.versetId;
        this.PropheteToVerset.propheteId = this.Soustheme;

        try {
          const response2 = await fetch(
            Constant.QORANI + "verset/addPropheteToVerset",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(this.PropheteToVerset),
            }
          );

          if (!response2.ok) {
            throw new Error("Error adding PropheteToVerset.");
          }
          if (response2.ok) {
            window.location.reload();
          }
        } catch (error) {
          alert(
            "Une erreur est survenue lors de l'ajout du verset, veuillez réessayer plus tard. Merci."
          );
        }
      }
    },
  },
  async created() {
    this.PropheteArray = await getAllProphete();
    this.suratArray = await getAllSurat();
    this.themeArray = await getAllTheme();
  },
};
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
